import React from "react";
import { Table } from "reactstrap";

const EquipmentTab = ({ assets = [] }) => {
    if (assets.length === 0) {
        return <p className="text-center text-muted py-4">No equipment recorded.</p>;
    }

    return (
        <Table responsive hover bordered>
            <thead style={{ backgroundColor: "#0147C8", color: "white" }}>
                <tr>
                    <th style={{ width: "50px" }}>#</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Location</th>
                    <th>Condition</th>
                </tr>
            </thead>
            <tbody>
                {assets.map((a) => {
                    const condition = a.observed_condition_name || a.observed_condition || "N/A";
                    return (
                        <tr key={a.id}>
                            <td className="fw-bold text-muted">{a.serialNumber || "-"}</td>
                            <td><strong>{a.name}</strong></td>
                            <td>{a.description || "-"}</td>
                            <td>{a.location || "-"}</td>
                            <td>{condition}</td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default EquipmentTab;